module.exports = __webpack_public_path__ + "static/media/Whitlist_IP.6e530e01.svg";